import { AfterViewInit, Component, ElementRef, ViewChild, inject, ChangeDetectionStrategy, signal } from '@angular/core';
import {PersonLoginService} from '../services/person-login-service';
import {StringUtils} from '../utils/string-utils';
import {UserStateService} from '../services/user-state.service';
import {Router} from '@angular/router';
import {MatProgressSpinner} from '@angular/material/progress-spinner';


declare const google: any;

@Component({
    selector: 'login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatProgressSpinner]
})
export class LoginComponent implements AfterViewInit {
  private readonly personLoginService = inject(PersonLoginService);
  private readonly userStateService = inject(UserStateService);
  private readonly router = inject(Router);


  readonly isBusy = signal<boolean>(undefined!);
  readonly errorMessage = signal<string>(undefined!);
  @ViewChild('loginButtonHolder') buttonHolder!: ElementRef;

  ngAfterViewInit(): void {
    const cachedLogin = this.personLoginService.getCachedLoginWithoutRedirect();
    if (cachedLogin) {
      this.login();
    } else {
      google.accounts.id.initialize({
        client_id: '1098157906705.apps.googleusercontent.com',
        callback: (data: any) => this.handleCredentialResponse(data),
      });
      google.accounts.id.renderButton(this.buttonHolder.nativeElement, {theme: 'white'});
    }
  }

  private handleCredentialResponse(data: any): void {
    this.isBusy.set(true);
    this.personLoginService.parseAuthCredential(data.credential).subscribe(response => {
      if (response) {
        this.login();
      } else {
        this.personLoginService.setApplicationCredential(data.credential);
        this.router.navigate(['userApplication']);
      }
      this.isBusy.set(false);
    }, error => this.handleError(error));
  }

  private login(): void {
    const targetUri = this.userStateService.redirectUri;
    if (targetUri && targetUri !== '/') {
      this.userStateService.redirectUri = undefined;
      this.router.navigate([targetUri]);
    } else {
      this.router.navigate(['main']);
    }
  }

  private handleError(error: any): void {
    this.isBusy.set(false);
    this.errorMessage.set(StringUtils.getErrorMessage(error));
  }

}
